import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import Page from '../../components/library/Page';
import Title from '../../components/library/Title';
import ConstantValues from '../../constants/ConstantValues';
import { SEO } from '../../common';
import { formatSEOTitle } from '../../function';
import { useTranslation } from 'react-i18next';

/* @ts-expect-error */
const DeveloperCard = ({ name, email }) => {
  return (
    <Card sx={{ width: 300, mr: 2, mb: 2 }}>
      <CardContent style={{ textAlign: 'center' }}>
        <Typography variant="h5" component="h2">
          {name}
        </Typography>
        <Typography color="textSecondary" gutterBottom>
          {email}
        </Typography>
      </CardContent>
    </Card>
  );
};

function AboutUs(){
  const { t } = useTranslation();

  useEffect(() => {
    if (document.location.hostname === ConstantValues.SiteHostname) { 
      ReactGA.pageview(window.location.pathname);
    }
  },[]);

  const Content = () => {
    return(
      <>
        <Title type="sub" title={t('about_us_mission_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('about_us_mission_content')}
        </Typography>

        <Title type="sub" title={t('about_us_why_built_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('about_us_why_built_content')}
        </Typography>
        <ul style={{marginLeft: '20px', marginBottom: '20px'}}>
          <li><Typography variant="body1">{t('about_us_accessibility')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_privacy')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_simplicity')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_quality')}</Typography></li>
        </ul>

        <Title type="sub" title={t('text_developers')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('content_about_us_developer')}
        </Typography>
        
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('about_us_team_description')}
        </Typography>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '30px' }}>
          <DeveloperCard name="😎Leo, Yip" email="lyip@lyip.win" />
          <DeveloperCard name="😜Vardy, Ng" email="vardyng1999@gmail.com" />
        </div>

        <Title type="sub" title={t('about_us_tech_stack_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('about_us_tech_stack_description')}
        </Typography>
        <Grid container spacing={2} style={{marginBottom: '20px'}}>
          <Grid item xs={12} sm={6} md={4}>
            <Card elevation={2} style={{padding: '15px'}}>
              <Typography variant="h6" gutterBottom>{t('about_us_frontend_title')}</Typography>
              <Typography variant="body2">{t('about_us_frontend_description')}</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card elevation={2} style={{padding: '15px'}}>
              <Typography variant="h6" gutterBottom>{t('about_us_backend_title')}</Typography>
              <Typography variant="body2">{t('about_us_backend_description')}</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card elevation={2} style={{padding: '15px'}}>
              <Typography variant="h6" gutterBottom>{t('about_us_security_title')}</Typography>
              <Typography variant="body2">{t('about_us_security_description')}</Typography>
            </Card>
          </Grid>
        </Grid>

        <Title type="sub" title={t('about_us_privacy_security_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('about_us_privacy_security_description')}
        </Typography>
        <ul style={{marginLeft: '20px', marginBottom: '20px'}}>
          <li><Typography variant="body1">{t('about_us_privacy_point_1')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_privacy_point_2')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_privacy_point_3')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_privacy_point_4')}</Typography></li>
        </ul>

        <Title type="sub" title={t('about_us_community_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('about_us_community_description')}
        </Typography>

        <Title type="sub" title={t('text_advertisement')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('content_about_us_ads')}
        </Typography>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('about_us_ads_description')}
        </Typography>

        <Title type="sub" title={t('about_us_future_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '15px'}}>
          {t('about_us_future_description')}
        </Typography>
        <ul style={{marginLeft: '20px', marginBottom: '20px'}}>
          <li><Typography variant="body1">{t('about_us_future_point_1')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_future_point_2')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_future_point_3')}</Typography></li>
          <li><Typography variant="body1">{t('about_us_future_point_4')}</Typography></li>
        </ul>

        <div style={{marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px'}}>
          <Typography variant="h6" gutterBottom>{t('about_us_contact_title')}</Typography>
          <Typography variant="body1">
            {t('about_us_contact_description')}
          </Typography>
        </div>
      </>
    );
  };
  const aboutUs = t('text_about_us');
  return(
    <Page pageTitle={aboutUs}>
      {/* @ts-expect-error */}
      <SEO
        title={formatSEOTitle(aboutUs)}
        description={t('seo_about_us_description')}
      />
      <Content/>
    </Page>
  );
}


export default AboutUs;
